import { assetUrl } from '../helper_functions/utilities'
import ChampionsMasteredIconWithFallBack from '../shared/ChampionMasteryIcon'

const ChampionMastery = ({ championMastery }) => {
    return (
        <section className="rounded-xl border border-zinc-800 bg-zinc-950 px-3 py-4 text-center text-zinc-200 shadow-[0_18px_36px_-28px_rgba(0,0,0,0.95)]">
            <div className="-mx-3 -mt-4 mb-3 border-b border-zinc-800 bg-zinc-900/65 px-3 py-3 text-left">
                <h2 className="text-[10px] font-bold uppercase tracking-[0.14em] text-zinc-500">CHAMPION MASTERY</h2>
            </div>

            <div className='flex mt-2 w-full justify-around gap-1'>
                {!championMastery?.length && (
                    <div className='rounded-md border border-amber-400/50 bg-amber-300/10 px-3 py-3 text-sm font-medium text-amber-100'>
                        No mastery data yet. Try updating.
                    </div>
                )}
                {championMastery?.map((mastery, index) => {
                    return (
                        <article key={index} className='flex flex-col items-center flex-1 text-white min-w-0'>
                            <div className='rounded-lg mb-1 relative'>
                                <div className='h-10 w-10 rounded-full border border-zinc-600 relative overflow-hidden'>
                                    <ChampionsMasteredIconWithFallBack src={assetUrl(`/champion_icons/${mastery?.name_id}.png`)} alt={`${mastery?.name} icon`} />
                                </div>
                                <div className="bg-zinc-900 text-[11px] font-bold px-1 rounded-md border border-zinc-700 absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2">
                                    {mastery?.level}
                                </div>
                            </div>
                            <img
                                width="40"
                                height="40"
                                alt={`Mastery level ${mastery?.level} crest`}
                                src={process.env.PUBLIC_URL + `/assets/mastery_icons/mastery-${(mastery?.level >= 10 ? "10" : mastery?.level)}.png`}
                            />
                            <div className='font-bold truncate w-full max-w-[60px] text-xs mt-0.5'>{mastery?.name}</div>
                            <div className='text-[11px] tracking-tight text-zinc-300'>{Intl.NumberFormat().format(mastery?.points)}</div>
                        </article>
                    )
                })}
            </div>
        </section>
    )
}

export default ChampionMastery
